import { useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Grain } from "@/components/decor";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Percorsi from "@/components/Percorsi";
import ChiSono from "@/components/ChiSono";
import Incontri from "@/components/Incontri";
import Calendario from "@/components/Calendario";
import IscrizioneForm from "@/components/IscrizioneForm";
import Contatti from "@/components/Contatti";
import AdminPage from "@/pages/AdminPage";
import PercorsoModal from "@/components/PercorsoModal";
import { scrollToId } from "@/lib/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Landing = () => {
  const [percorso, setPercorso] = useState("gruppo_presenza");
  const [ciclo, setCiclo] = useState("ciclo_1");
  const [modalPercorso, setModalPercorso] = useState(null);
  const [posti, setPosti] = useState(null);

  const refreshPosti = useCallback(() => {
    axios
      .get(`${API}/posti`)
      .then(({ data }) => setPosti(data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refreshPosti();
  }, [refreshPosti]);

  return (
    <div className="App min-h-screen bg-[#FAF8F5]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Percorsi selected={percorso} onSelect={setPercorso} posti={posti} onOpenModal={setModalPercorso} />
        <ChiSono />
        <Incontri />
        <Calendario posti={posti} />
        <IscrizioneForm percorso={percorso} setPercorso={setPercorso} ciclo={ciclo} setCiclo={setCiclo} posti={posti} onIscritto={refreshPosti} />
        <Contatti />
      </main>
      <PercorsoModal
        percorso={modalPercorso}
        posti={posti}
        onClose={() => setModalPercorso(null)}
        onChoose={(p, c) => {
          setPercorso(p);
          if (c) setCiclo(c);
          setModalPercorso(null);
          setTimeout(() => scrollToId("iscrizione"), 200);
        }}
      />
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <Grain />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
